// Aviso antes de passar à fase seguinte: mostra o que falta preencher e deixa escolher
// entre preencher agora ou avançar mesmo assim (fica registado como incompleto onde isso se aplica).
import { AlertTriangle } from "lucide-react";
import { ds } from "./desenho";

const GRADIENTE = "linear-gradient(90deg, #0B1B3D 0%, #1E3566 45%, #4A6BA8 100%)";

// O que falta numa proposta, conforme o passo que se vai dar
export function faltasDaProposta(p, passo) {
  const f = [];
  if (!p.imovel_ref) f.push("Referência do imóvel");
  if (!p.valor_proposto) f.push("Valor proposto");
  if (!p.lead_comprador_id && !p.comprador_ext_colega) f.push("Comprador");
  if (passo === "aceitar" && !p.valor) f.push("Valor aceite");
  if (passo === "cpcv") {
    if (!p.lead_vendedor_id && !p.consultor_ang_ext_colega) f.push("Vendedor");
    if (!p.valor && !p.valor_proposto) f.push("Valor do negócio");
  }
  return f;
}

export default function AlertaFaltas({ titulo, faltas = [], rotuloAvancar = "Avançar mesmo assim", onPreencher, onAvancar, onCancelar }) {
  return (
    <div role="alertdialog" aria-modal="true" aria-label={titulo} onClick={onCancelar} style={{ position: "fixed", inset: 0, background: "rgba(10,18,40,.45)", zIndex: 9500, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, width: 460, maxWidth: "100%", fontFamily: ds.letra, color: ds.tinta, overflow: "hidden" }}>
        <div style={{ background: GRADIENTE, color: "#fff", padding: "14px 20px", fontSize: 16, fontWeight: 700, display: "flex", alignItems: "center", gap: 8 }}><AlertTriangle size={18} aria-hidden="true" />{titulo}</div>
        <div style={{ padding: 20, display: "grid", gap: 12 }}>
          <span style={{ fontSize: 14, color: ds.tinta2 }}>Ainda falta preencher {faltas.length === 1 ? "1 campo" : faltas.length + " campos"}:</span>
          <ul style={{ margin: 0, paddingLeft: 18, fontSize: 14, fontWeight: 600, display: "grid", gap: 3 }}>{faltas.map((x) => <li key={x}>{x}</li>)}</ul>
          <span style={{ fontSize: 12.5, color: ds.tinta3 }}>Podes preencher agora ou avançar e completar mais tarde.</span>
          <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
            <button onClick={onCancelar} style={bt}>Cancelar</button>
            <button onClick={onAvancar} style={bt}>{rotuloAvancar}</button>
            <button onClick={onPreencher} style={{ ...bt, border: 0, color: "#fff", fontWeight: 700, background: GRADIENTE }}>Preencher agora</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const bt = { border: "1.5px solid " + ds.linha, borderRadius: 8, padding: "8px 14px", fontSize: 13, background: "#fff", color: ds.tinta2, cursor: "pointer", fontFamily: "inherit" };
